<template>
  <v-flex xs12 row>
	 <v-layout py-3>
   		<v-flex xs12 sm6 offset-sm3>
   			<v-card>
	   			<v-card-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="400px" v-if="hasCreateAccess">
              <v-btn slot="activator" round color="primary" dark small class="ml-4">Add New</v-btn>
              <v-form v-model="validForm">
                <v-card>
                  <v-card-title>
                    <span class="headline" v-text="item.id ? 'Update Extra Discount' : 'Add Extra Discount'"></span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md py-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field :rules="rules" counter="100" v-model="item.title" label="Narration"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field :rules="percentRules" maxlength="5" v-model="item.discount_percent" label="Percentage"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat :disabled="processing" @click.native="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="item.id ? updateItem() : addItem()" v-text="item.id ? 'Update' : 'Save'"></v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="discounts"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <td>{{ props.item.title }}</td>
				      <td>{{ props.item.discount_percent }}</td>
              <td class="align-center justify-center layout px-0">
                <edit-btn :item="props.item" />
                <delete-btn :item="props.item" />
              </td>
				    </template>
				    <template slot="no-data" v-if="!processing && !discounts.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <action-dialog action="delete" :status="deleteDialog" @close="closeDeleteDialog" @success="deleteItem(discounts)" />

			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    name: 'ExtraDiscounts',
    data () {
      return {
        model: 'extradiscount',
      	title: "Extra Discounts",
        validForm: false,
      	processing: false,
        dialog: false,
        deleteDialog: false,
      	discounts: [],
        headers: [
          { text: 'Narration', value: 'title'},
          { text: 'Dicount Percent', value: 'discount_percent'},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        item: {},
        defaultItem: {
          id: "",
          title: "",
          discount_percent: 0,
          is_deleted: false
        },
        deletingItem: null,
        rules: [
          v => !!v || 'Narration is required',
          v => v && v.length >= 3 || 'Must be more than 5 characters',
          v => v && v.length <= 50 || 'Maximum 100 characters allowed'
        ],
        percentRules: [
          v => !!v || 'Percentage is required',
          v => /^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Percentage must be valid'
        ]
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Extra Discounts',
	          disabled: true
	        },
	        {
	          text: 'View',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Extra Discounts')
    },
    methods: {

      getExtraDiscounts () {
        this.processing = true
        this.axios.get(this.config.apis.getExtraDiscounts)
          .then((response) => {
            this.processing = false
            if (response && response.data && response.data.success && response.data.data) {
            	this.discounts = response.data.data
            }
            else{
            	this.discounts = []
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },
      addItem () {
        this.processing = true
        this.axios.post(this.config.apis.addExtraDiscount, this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              
              let new_item = this.extend({}, this.item)
              new_item.id = response.data.data.id

              this.discounts.unshift(new_item)

              this.notifySuccess('insertSuccess')
              this.close()
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.close()
          })
      },
      updateItem () {
      	this.processing = true
        this.axios.put(this.config.apis.updateExtraDiscount.replace(":id", this.item.id), this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              this.notifySuccess('updateSuccess')
              this.close()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.close()
          })
      },

      editItem (item) {
        this.item = item
        this.dialog = true
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
        }, 300)
      }

    },
    mounted () {
    	this.getExtraDiscounts()
      this.item = this.extend({}, this.defaultItem)
    },

    computed: {

    }

  }
</script>
